<script>
import moment from "moment";
import ClientFactory from "@/api/ClientFactory";
const iOfficeApi = ClientFactory.get("ioffices");
import { mapState } from "vuex";

export default {
    data: () => ({
        state:{
          loading: false,
        },
        letter: 0,
        document:0,
        meetingSchedule: 0,
        period: "",
        time_select:1,
        data_time:[
        {
          value: 1,
          label: "Ngày",
        },
        {
          value: 2,
          label: "Tháng",
        },
        {
          value: 3,
          label: "Quý",
        },
      ],
    }),
    methods: {
        async getInfo() {
            this.state.loading = true;
            const {username} = this.AppActiveUser;
            const time = this.convertRange(this.time_select);
            const {data} = await iOfficeApi.getMeetingStatistics(username, time.from, time.to);

            this.meetingSchedule = data[0].meetingschedule;
            this.letter = data[0].letter;
            this.document = data[0].document;
            this.period = data[0].period;

            // hide loading
            this.state.loading = false;
        },
        convertRange(type){
            switch (type) {
                case 1: // Hôm nay
                    return {
                        from: moment().format("DD/MM/YYYY"),
                        to: moment().format("DD/MM/YYYY")
                    }
                case 2: //Tháng
                    return {
                        from: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format("DD/MM/YYYY"),
                        to: moment(new Date(new Date().getFullYear(), new Date().getMonth()+1, 0)).format("DD/MM/YYYY")
                    }
                case 3: //Quý
                    return {
                        from: moment().startOf('quarter').format("DD/MM/YYYY"),
                        to: moment().endOf('quarter').format("DD/MM/YYYY")
                    }
            }
        }

    },
    async created() {
        this.getInfo();

    },
    computed: {
        ...mapState("auth", ["AppActiveUser"]),
    },
    destroyed() {
        // hide loading
        this.state.loading = false;
    }
}
</script>

<template>
    <div class="meeting-statistics-component">
        <CCard class="pb-0">
            <CCardHeader class="pt-0 pb-0">
                <div class="d-flex flex-wrap justify-content-between align-items-center">
                    <span class="card-header-title">Phòng họp</span>
                    <CSelect
                            :options='data_time'
                            :value.sync="time_select"
                            @change="getInfo()"
                            class="mb-sm-1"
                        />
                </div>
            </CCardHeader>
            <CRow class="p-2" style="min-height:225px">
              <CCol sm="12">
                  <CCard class="p-2">
                <b-overlay
                    :show="state.loading"
                    no-wrap
                    spinner-variant="success"
                    spinner-type="grow"
                    rounded="sm"
                    opacity="0.8"
                    z-index="1000"
                />
                <p>Thời gian: <br>{{period}}</p>
                <p>Giấy mời: <CBadge color="success">{{letter}}</CBadge></p>
                <p>Văn bản có hạn xử lý: <CBadge color="success">{{document}}</CBadge></p>
                <p>Lịch họp: <CBadge color="success">{{meetingSchedule}}</CBadge></p>
                <!-- <span class="center">{{period}}</span> -->
                </CCard>
                </CCol>
            </CRow>
        </CCard>
    </div>
</template>

<style lang="scss">
  .meeting-statistics-component{
    .form-control {
        margin-top: 3px;
        width: auto; 
        height: calc(0.75em + 0.75rem + 1px);
        padding: 0rem 0rem;
    }
    .card-header-title {
        margin-bottom: 0rem;
    }
  }
</style>